import { Form, Formik } from "formik";
import Callout from "../UI/Callout";
import { useState } from "react";
import { handleAPIError } from "../../utils/index.jsx";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import TextInput from "../UI/TextInput";
import PasswordInput from "../UI/PasswordInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { SMTP_INITIAL_VALUES, smtpSchema } from "../../models/monCompte";
import { SmtpProviders } from "../../models/smtp";

export default function SmtpForm({ onSubmit, smtp }) {
  const [error, setError] = useState("");
  const [description, setDescription] = useState("");
  const [tuto, setTuto] = useState("");

  async function submitHandler(values) {
    setError("");
    try {
      await onSubmit(sanitizeValues(values));
    } catch (error) {
      setError(handleAPIError(error));
    }
  }
  const initialValues = toInitialValuesFromSchema(
    smtpSchema,
    smtp,
    SMTP_INITIAL_VALUES,
  );
  if (initialValues.serveur === "") {
    initialValues.mail = "";
    initialValues.port = "";
  }
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={smtpSchema}
      onSubmit={submitHandler}
    >
      {({ handleChange, setFieldValue }) => {
        function checkSmtpOptions(mail) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (mail && emailRegex.test(mail)) {
            const domain = mail.split("@")[1];
            const provider = SmtpProviders[domain];
            if (provider) {
              setFieldValue("serveur", provider.serveur);
              setFieldValue("port", provider.port);
              setDescription(provider.description);
              setTuto(provider.tuto);
            }
          }
        }
        return (
          <Form>
            <TextInput
              name={"mail"}
              label={"Adresse email"}
              placeholder={"youremail@gmail.com"}
              onChange={(e) => {
                handleChange(e);
                checkSmtpOptions(e.target.value);
              }}
            />
            <PasswordInput
              name={"password"}
              label={"Mot de passe de l'adresse email"}
              placeholder={"Mot de passe"}
            />
            <div className={"flex wrap gap10"}>
              <TextInput
                name={"serveur"}
                label={"Adresse du serveur de messagerie"}
                placeholder={"smtp.gmail.com"}
              />
              <TextInput name={"port"} label={"Port"} placeholder={"465"} />
            </div>
            <p className={"marginB10"}>{description}</p>
            {tuto && (
              <p className={"marginB10"}>
                <a href={tuto} target="_blank" rel="noreferrer">
                  Cliquez ici pour voir notre tutoriel
                </a>
              </p>
            )}
            <div className={"text-right"}>
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        );
      }}
    </Formik>
  );
}
